import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PerformanceReportDTO } from 'src/app/models/performanceReportDTO';
import { CalculationsService } from 'src/app/services/calculations.service';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls:  ['../../app.component.scss'],
  standalone: false
})
export class GenerateReportComponent implements OnInit {
  @Input() report : PerformanceReportDTO;
  constructor (
    public bsModalRef : BsModalRef,
    public calculationService: CalculationsService
    ) { }

  ngOnInit(): void {
  }

  setDate(value){
    let months = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];
    let date = value.split("-");
    this.report.date = date[2]+ " " +months[parseInt(date[1])-1] + " " + date[0];
  }

  generateReport(){
    this.calculationService.generateReport(this.report);
    this.bsModalRef.hide();
  }
  cancel(){
    this.bsModalRef.hide();
  }
}
